import React from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./user.css";
import { Link } from "react-router-dom";
import { logout, setSelectedAddress, set_profile, defaultAddress, set_OfficeAddress, setAddress, setLoading, setEdit } from "../../../store/Actions/authActions";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { connect, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Axios from "axios";
import Config from "../../Config";
import { cartApi, fetchCartItem, getProducts, selectAddress } from "../../../store/Actions/cartActions";
import cookies from "js-cookie";
import EditAddress from "../Modals/NewAddress/EditAddress";
import DeliveryDetail from "../DeliveryDetail";
import ChangeAddress from "../DeliveryDetail/changeAddressModal";
import "./topbar.css";
import { websiteUrl } from "../../../utils/support";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
// import EditAddress from "../Modals/EditAddress";
// import EditAddress from "../NewAddress/EditAddress/index";

const NavSprite = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <symbol id="nav-location" viewBox="0 0 512 512">
        <path d="M256,48c-79.5,0-144,61.39-144,137,0,87,96,224.87,131.25,272.49a15.77,15.77,0,0,0,25.5,0C304,409.89,400,272.07,400,185,400,109.39,335.5,48,256,48Z" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
        <circle cx="256" cy="192" r="48" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
      </symbol>
      <symbol id="nav-chevron" viewBox="0 0 512 512">
        <polyline points="112 184 256 328 400 184" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48px" }} />
      </symbol>
      <symbol id="nav-home" viewBox="0 0 512 512">
        <path d="M80,212V448a16,16,0,0,0,16,16h96V328a24,24,0,0,1,24-24h80a24,24,0,0,1,24,24V464h96a16,16,0,0,0,16-16V212" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
        <path d="M480,256,266.89,52c-5-5.28-16.69-5.34-21.78,0L32,256" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
      </symbol>
      <symbol id="nav-business" viewBox="0 0 512 512">
        <rect x="80" y="48" width="240" height="416" rx="24" style={{ fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "32px" }} />
        <path d="M320,208H408a24,24,0,0,1,24,24V464H320" style={{ fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "32px" }} />
        <line x1="144" y1="128" x2="176" y2="128" style={{ stroke: "currentColor", strokeLinecap: "round", strokeWidth: "32px" }} />
        <line x1="224" y1="208" x2="256" y2="208" style={{ stroke: "currentColor", strokeLinecap: "round", strokeWidth: "32px" }} />
        <line x1="144" y1="288" x2="176" y2="288" style={{ stroke: "currentColor", strokeLinecap: "round", strokeWidth: "32px" }} />
      </symbol>
      <symbol id="nav-pencil" viewBox="0 0 512 512">
        <polygon points="364.13 125.25 87 403 64 448 108.99 425 386.75 147.87 364.13 125.25" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
        <path d="M420.69,68.69,398.07,91.32l22.62,22.63,22.62-22.63a16,16,0,0,0,0-22.63h0A16,16,0,0,0,420.69,68.69Z" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32px" }} />
      </symbol>
      <symbol id="nav-check" viewBox="0 0 512 512">
        <polyline points="416 128 192 384 96 288" style={{ fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "44px" }} />
      </symbol>
    </defs>
  </svg>
);

const NavIcon = ({ name, ...rest }) => (
  <svg viewBox="0 0 512 512" aria-hidden="true" {...rest}>
    <use href={`#${name}`} />
  </svg>
);

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      mobileDropdown: false,
      isOpen: false,
      username: null,
      defaultAddress: null,
      firstName: null,
      lastName: null,
      detailSelectedAddress: [],
      en: null,
      edit: false,
      selected: [],
    };
    // this.dropdownRef = React.createRef()
  }



  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handleEditDelivery = () => {
    if (this.props.editt === true || this.props.editOrder === true)
      this.props?.cartItems?.forEach((p) => {
        this.props?.cartApi(p, "destroyAllProducts");
        this.props?.setEdit(false)
      })
  }

  /*
   * Les pages se calent sous la barre avec calc(100vh - var(--wa-nav-h)).
   * Sur mobile la barre passe sur plusieurs lignes : on publie sa vraie
   * hauteur pour que le bas des pages ne soit pas coupé.
   */
  navRef = React.createRef();

  publishNavHeight = () => {
    const height = this.navRef.current?.offsetHeight;
    if (height) {
      document.documentElement.style.setProperty("--wa-nav-h", `${height}px`);
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.publishNavHeight();
    if (window.ResizeObserver && this.navRef.current) {
      this.navObserver = new ResizeObserver(this.publishNavHeight);
      this.navObserver.observe(this.navRef.current);
    }
    // this.props?.getProducts();
    if (this.props.history.location.pathname === "/home") {
      this.props.setLoading(true)
      this.fetchData()
    }
    const uid = this.props?.authUser?.user_uid;
    const client = this.props?.authUser?.user_client;
    const accessToken = this.props?.authUser?.user_access_token;

    this.setState({
      uid,
      client,
      accessToken,
    });
    this.profile()
    this.loadPartner()
    $("#app-container").removeClass("menu-default");
    $("#app-container").removeClass("show-spinner");
    const office = this.props?.officeAddress.filter(add => add.is_default === true);
    const home = this.props?.deliveryAddress.filter(add => add.is_default === true);

    if (office?.length > 0) {
      this.setState({ ...this.state, defaultAddress: office?.[0]?.address, detailSelectedAddress: office })
    }
    else if (home?.length > 0) {
      this.setState({ ...this.state, defaultAddress: home?.[0]?.address, detailSelectedAddress: home })
    }
    else {
      this.setState({ ...this.state, defaultAddress: this.props?.t("Complete Your Address") })
    }
  }

  /* « Votre pressing » : le laundry partner de l'adresse choisie. */
  loadPartner = () => {
    const user = this.props?.authUser;
    if (!user?.user_uid) return;
    Axios({
      url: `${Config.apiURL}/customer/laundry_partner`,
      method: "GET",
      headers: { uid: user.user_uid, client: user.user_client, "access-token": user.user_access_token },
    })
      .then((response) => {
        const data = response?.data;
        const partner = data?.laundry_partner ?? data?.partner ?? data?.data ?? data;
        this.setState({ partnerName: partner?.name || null, partnerSite: websiteUrl(partner?.website) });
        if (!partner?.website) this.loadPartnerSite();
      })
      .catch(() => this.setState({ partnerName: null, partnerSite: null }));
  };

  /*
   * laundry_partner n'expose pas encore `website` ; GET /customer/reviews,
   * qui décrit le pressing d'une adresse, le donne. Même adresse que
   * laundry_partner : celle choisie, sinon le point de collecte par défaut,
   * sinon l'adresse de livraison par défaut.
   */
  loadPartnerSite = () => {
    const user = this.props?.authUser;
    const address =
      this.props?.sAddress?.[0] ||
      (this.props?.officeAddress || []).find((item) => item?.is_default) ||
      (this.props?.deliveryAddress || []).find((item) => item?.is_default);
    if (!user?.user_uid || !address?.id) return;
    Axios({
      url: `${Config.apiURL}/customer/reviews`,
      method: "GET",
      headers: { uid: user.user_uid, client: user.user_client, "access-token": user.user_access_token },
      params: {
        type: address.type === "CollectionPoint" ? "CollectionPoint" : "DeliveryAddress",
        id: address.id,
      },
    })
      .then((response) => this.setState({ partnerSite: websiteUrl(response?.data?.laundry_place?.website) }))
      .catch(() => {});
  };

  componentDidUpdate(prevProps) {
    if (prevProps.sAddress !== this.props.sAddress) {
      this.loadPartner();
    }
  }

  profile = () => {
    const profile = this.props?.userProfile?.firstName
    this.props?.set_profile()
  }

  addAddress = () => {
    this.props.history.push("/use-wosh")
  }


  handleLogout = () => {
    if (this.props.editt === true || this.props.editOrder === true)
      this.props?.cartItems?.forEach((p) => {
        this.props?.cartApi(p, "destroyAllProducts");
      })
    // setTimeout(()=>{
    this.props.logout(this.props);
    // },1000)
    // .then((response) => {
    //   window.location.href = "https://woshfrontweb.herokuapp.com/";
    //   return response;
    // })
    // .catch((err) => {
    //   // window.location.href = "https://woshfrontweb.herokuapp.com/home";
    //   return err;
    // });
  };



  fetchData = async () => {
    await this.props.set_OfficeAddress();
    await this.props.setAddress();
    await this.props?.getProducts();
    await this.props?.fetchCartItem();
    this.setAdd();
    this.props.setLoading(false)
  }

  setDefaultAddress = (address) => {
    this.props.setLoading(true)
    // debugger
    this.props.defaultAddress(address).then(() => {
      this.fetchData()

    })
  }

  componentWillUnmount() {
    this.navObserver?.disconnect();
    document.documentElement.style.removeProperty("--wa-nav-h");
    this.setAdd();
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setAdd = () => {
    let h = this.props?.hAddress?.filter((item) => {
      return item?.is_default === true;
    });
    let o = this.props?.oAddress?.filter((item) => {
      return item?.is_default === true;
    });

    if (h?.length > 0) {
      this.props.setSelectedAddress(h[0]?.id, "home");
      this.props?.selectAddress("home");
      this.setState({ ...this.state, defaultAddress: h[0]?.address, detailSelectedAddress: h })
    }

    if (h?.length === 0 && o?.length > 0) {
      this.props?.setSelectedAddress(o[0]?.id, "office");
      this.props?.selectAddress("office");
      this.setState({ ...this.state, defaultAddress: o[0]?.address, detailSelectedAddress: o })
    }
  };


  // defaultAddress = async (address) => {
  //   console.log(address)
  //   await Axios({
  //     url: `${Config.apiURL}/customer/default_addresses`,
  //     method: "POST",
  //     data: {
  //       id: address.id,
  //       address_type: address.type
  //     },
  //     headers: {
  //       uid: `${this.state.uid}`,
  //       client: `${this.state.client}`,
  //       "access-token": `${this.state.accessToken}`,
  //     },
  //   }).then((response) => {

  //     this.setState({ defaultAddress: address.address })

  //   })
  //     .catch((error) => {
  //       return (
  //         console.log('error')
  //       )
  //     });
  // }

  handleSubmit = (selected) => {
    if (this.state.detailSelectedAddress?.[0]?.id != selected.id) {
      this.setDefaultAddress(selected)
    }
  }

  blacklist = ["/sign-in", "/forgot-password", "/connect-point", "/use-wosh", "/thank-you", "/delivery-details", "/personal-details", "/new-user-password"]

  /*
   * componentDidMount écoute déjà `mousedown` : sans ce gestionnaire, le
   * sélecteur d'adresse ne se refermait qu'en recliquant dessus et restait
   * ouvert par-dessus la page. Les deux variantes du menu (desktop et
   * mobile) portent la classe `dropdown`, d'où le test par `closest`.
   */
  handleClickOutside = (event) => {
    if (!this.state.isOpen && !this.state.dropdown) {
      return;
    }

    const target = event.target;

    if (
      target instanceof Element &&
      target.closest(".dropdown, .wosh-nav__addr, .wosh-nav__user")
    ) {
      return;
    }

    this.setState({ isOpen: false, dropdown: false });
  };


  /** Adresses domicile puis points de collecte, dans l'ordre du menu. */
  get addressRows() {
    const home = (this.props.deliveryAddress || []).map((item) => ({
      item,
      icon: "nav-home",
      label: this.props.t("Home address"),
    }));
    const office = (this.props.officeAddress || []).map((item) => ({
      item,
      icon: "nav-business",
      label: this.props.t("Collection point"),
    }));

    return [...home, ...office];
  }

  /**
   * Choisir l'adresse déjà active ne change rien : pas de pop-up, pas de
   * panier vidé. Sinon on demande confirmation (pop-up 05).
   */
  pickAddress = (item) => {
    if (item.id === this.state.detailSelectedAddress?.[0]?.id) {
      this.setState({ isOpen: false });
      return;
    }

    this.setState({ selected: item, isOpen: false, changeOpen: true });
  };

  renderAddressMenu() {
    const { t } = this.props;
    const selectedId = this.state.detailSelectedAddress?.[0]?.id;

    return (
      <>
        <div className="wosh-nav__menu">
          <div className="wosh-nav__eyebrow">{t("Pickup address")}</div>

          {this.addressRows.map(({ item, icon, label }) => (
            <div
              key={`${icon}-${item.id}`}
              role="button"
              tabIndex={0}
              className={`wosh-nav__row${
                item.id === selectedId ? " wosh-nav__row--on" : ""
              }`}
              onClick={() => this.pickAddress(item)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  this.pickAddress(item);
                }
              }}
            >
              <span className="wosh-nav__row-badge">
                <NavIcon name={icon} />
              </span>

              <span className="wosh-nav__row-body">
                <span className="wosh-nav__row-title">{label}</span>
                <span className="wosh-nav__row-line">{item.address}</span>
              </span>

              {/* Le crayon ouvre l'édition sans changer l'adresse courante. */}
              <button
                type="button"
                className="wosh-nav__pencil"
                aria-label={t("Edit")}
                onClick={(event) => {
                  event.stopPropagation();
                  this.setState({ isOpen: false });
                  this.props.history.push("/delivery-details", {
                    edit: true,
                    editable: item,
                  });
                }}
              >
                <NavIcon name="nav-pencil" />
              </button>

              {item.id === selectedId && (
                <span className="wosh-nav__tick">
                  <NavIcon name="nav-check" />
                </span>
              )}
            </div>
          ))}

          <div className="wosh-nav__divider" />

          <button type="button" className="wosh-nav__add" onClick={this.addAddress}>
            <span>+</span>
            {t("Add an address")}
          </button>
        </div>
      </>
    );
  }

  renderUserMenu() {
    const { t } = this.props;

    return (
      <>
        <div className="wosh-nav__user-menu">
          <Link
            className="wosh-nav__item"
            to="/profile"
            onClick={() => this.setState({ dropdown: false })}
          >
            {t("Profile")}
          </Link>
          <Link
            className="wosh-nav__item"
            to="/paymentMethod"
            onClick={() => this.setState({ dropdown: false })}
          >
            {t("Payment methods")}
          </Link>
          <button
            type="button"
            className="wosh-nav__item wosh-nav__item--danger"
            onClick={this.handleLogout}
          >
            {t("logout")}
          </button>
        </div>
      </>
    );
  }

  render() {
    const { t } = this.props;
    const { isOpen, dropdown } = this.state;

    if (this.blacklist.includes(this.props.history.location.pathname)) {
      return null;
    }

    /* Hors navigation (écrans d'onboarding), seul le wordmark est affiché. */
    if (!this.props.isNav) {
      return (
        <nav className="wosh-nav" ref={this.navRef}>
          <NavSprite />
          <Link to="/home" className="wosh-nav__brand" onClick={this.handleEditDelivery}>
            WOSH
          </Link>
        </nav>
      );
    }

    const path = this.props.history.location.pathname;
    const onOrders = path.startsWith("/orders");
    const firstName = this.props.userProfile?.firstName || this.props.username?.user_name || "";

    return (
      <>
        <nav className="wosh-nav" ref={this.navRef}>
          <NavSprite />

          <div className="wosh-nav__left">
            <Link to="/home" className="wosh-nav__brand" onClick={this.handleEditDelivery}>
              WOSH
            </Link>
            {this.state.partnerName && (
              <>
                <span className="wosh-nav__sep" aria-hidden="true" />
                {this.state.partnerSite ? (
                  <a
                    className="wosh-nav__partner wosh-nav__partner--link"
                    href={this.state.partnerSite}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="wosh-nav__overline">{t("Your laundry")}</span>
                    <span className="wosh-nav__partner-name">{this.state.partnerName}</span>
                  </a>
                ) : (
                  <div className="wosh-nav__partner">
                    <span className="wosh-nav__overline">{t("Your laundry")}</span>
                    <span className="wosh-nav__partner-name">{this.state.partnerName}</span>
                  </div>
                )}
              </>
            )}
          </div>

          <div className="wosh-nav__addr">
            <button
              type="button"
              className={`wosh-nav__pill${isOpen ? " wosh-nav__pill--open" : ""}`}
              aria-expanded={isOpen}
              onClick={this.handleClick}
            >
              <span className="wosh-nav__pin">
                <NavIcon name="nav-location" />
              </span>
              <span className="wosh-nav__pill-text">
                <span className="wosh-nav__overline">{t("Pickup & delivery")}</span>
                <span className="wosh-nav__pill-label">
                  {this.state.defaultAddress || t("Add an address")}
                </span>
              </span>
              <NavIcon name="nav-chevron" className="wosh-nav__chevron" />
            </button>

            {isOpen && this.renderAddressMenu()}
          </div>

          <div className="wosh-nav__right">
            <Link
              to="/home"
              className={`wosh-nav__tab${onOrders ? "" : " wosh-nav__tab--on"}`}
              aria-current={onOrders ? undefined : "page"}
            >
              {t("Order")}
            </Link>
            <Link
              to="/orders"
              className={`wosh-nav__tab${onOrders ? " wosh-nav__tab--on" : ""}`}
              aria-current={onOrders ? "page" : undefined}
            >
              {t("My orders")}
            </Link>

            <div className="wosh-nav__user">
              <button
                type="button"
                className={`wosh-nav__user-pill${dropdown ? " wosh-nav__user-pill--open" : ""}`}
                aria-expanded={dropdown}
                onClick={() => this.setState({ dropdown: !dropdown })}
              >
                <span className="wosh-nav__user-name">{firstName}</span>
                <NavIcon name="nav-chevron" className="wosh-nav__chevron" />
              </button>

              {dropdown && this.renderUserMenu()}
            </div>
          </div>
        </nav>

        <ChangeAddress
          open={Boolean(this.state.changeOpen)}
          onClose={() => this.setState({ changeOpen: false })}
          handleSubmit={() => {
            this.handleSubmit(this.state.selected);
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state?.auth?.user,
  deliveryAddress: state?.auth?.homeAddress,
  userProfile: state?.auth?.profileUser,
  officeAddress: state?.auth?.officeAddress,
  authUser: state?.auth?.user,
  sAddress: state?.auth?.selectedAddress,
  address: state?.cart?.home,
  hAddress: state?.auth?.homeAddress,
  oAddress: state?.auth?.officeAddress,
  editt: state?.auth?.edit,
  editOrder: state?.auth?.editOrder,
  products: state?.auth?.sortedCategories,
  cartItems: state?.cart?.cartItems,
});


// const mapDispatchToProps = {};

// export default connect(mapStateToProps, mapDispatchToProps)(OnHangersTab);
export default compose(withRouter, withTranslation(), connect(mapStateToProps, { setLoading, logout, set_profile, defaultAddress, setAddress, set_OfficeAddress, selectAddress, setSelectedAddress, fetchCartItem, getProducts, cartApi, setEdit }))(Header);
